import React from 'react';
import SvgIcon from 'components/SvgIcon';

export default (name, children) => {
  const FactoryIcon = props => {
    const newProps = Object.assign({}, props, { name: name.toLowerCase() });
    return <SvgIcon {...newProps}>{children}</SvgIcon>;
  };
  FactoryIcon.displayName = name;
  FactoryIcon.defaultProps = SvgIcon.defaultProps;
  FactoryIcon.propTypes = SvgIcon.propTypes;
  return FactoryIcon;
};
